import * as actionTypes from '../types/metric';

const initialState = {
  listTypes: null,
  listData: null,
  listDataAll: null,
  listShort: null,
  listDetailed: null,
  listAddedStocks: null
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.METRIC_PIECE_DATA_SUCCESS:
      return {
        ...state,
        listData: payload
      };
    case actionTypes.METRIC_PIECE_DATA_ALL:
      return {
        ...state,
        listDataAll: null
      };
    case actionTypes.METRIC_PIECE_DATA_ALL_SUCCESS:
      return {
        ...state,
        listDataAll: payload
      };
    case actionTypes.METRIC_PIECE_TYPES_LIST_SUCCESS:
      return {
        ...state,
        listTypes: payload
      };

    case actionTypes.METRIC_USER_ACTIVITY_SHORT_SUCCESS:
      return {
        ...state,
        listShort: payload
      };
    case actionTypes.METRIC_USER_ACTIVITY_DETAILED_SUCCESS:
      return {
        ...state,
        listDetailed: payload
      };
    case actionTypes.METRIC_ADDED_STOCKS_SUCCESS:
      return {
        ...state,
        listAddedStocks: payload
      };

    default:
      return state;
  }
};

export default reducer;
